export const GeneralSettingKeys = [
  'preferences',
  'integrations',
  'notifications',
  'plans',
  'experimental-flags',
  'admin-settings',
  'workspaces',
  'augment-prompt',
  'about',
  'shortcuts',
] as const;

export const DEFAULT_SETTING_TAB = 'preferences' as const satisfies GeneralSettingKey;

export const WorkspaceSubTabs = ['preference', 'properties'] as const;

export type GeneralSettingKey = (typeof GeneralSettingKeys)[number];

export type WorkspaceSubTab = (typeof WorkspaceSubTabs)[number];

export type ActiveTab =
  | GeneralSettingKey
  | 'account'
  | `workspace:${WorkspaceSubTab}`;

const VALID_TABS = new Set<string>([...GeneralSettingKeys, 'account']);

export function resolveSettingTab(tab: string): ActiveTab {
  if (VALID_TABS.has(tab) || tab.startsWith('workspace:')) return tab as ActiveTab;
  return DEFAULT_SETTING_TAB;
}
